<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>

    <Process />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Process from "../../components/Workflow/Definitions/Process/Process.vue";
export default {
  components: { LandingToolbar, Process },
};
</script>
